import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ShoesIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.0963 19.4185C16.0981 16.8675 17.2009 13.6571 17.2009 10.378V3.92655C17.2009 3.6303 17.4453 3.39085 17.7464 3.39085H22.2742V1H14.7689V6.91416C14.7689 10.4268 13.5858 13.8697 11.4378 16.6109C8.77222 19.9971 6.06956 22.2492 3.40397 23.3056C2.55144 23.6452 2 24.4172 2 25.2727V25.4394C2 26.0238 2.25036 26.5863 2.68726 26.9833C3.1247 27.3808 3.69306 27.573 4.28105 27.5301C4.42068 27.5216 4.56631 27.5055 4.70922 27.4916C5.04794 26.7346 5.68392 26.1105 6.52281 25.7774C8.97731 24.8019 11.596 22.6021 14.0963 19.4185Z"
        fill="currentColor"
      />
      <path
        d="M27.157 15.2765C26.2805 14.1215 25.7977 12.6923 25.7977 11.2518V4.46172H18.2913V10.3775C18.2913 13.8923 17.1083 17.3346 14.9598 20.0721C12.304 23.4545 9.60348 25.7083 6.9319 26.7695C6.07774 27.1091 5.52575 27.8811 5.52575 28.7371V28.8989C5.52575 29.4855 5.77665 30.0496 6.21464 30.4481C6.65099 30.844 7.21662 31.039 7.80407 30.9935C10.5095 30.7861 14.5528 30.0335 18.4517 27.6218C19.992 26.6683 21.775 26.0511 23.7512 25.7881C24.6016 25.675 25.3842 25.4656 26.0775 25.1661C28.07 24.3069 29.3573 22.3006 29.3573 20.0555C29.3573 18.8443 28.9514 17.6428 28.214 16.6715L27.157 15.2765Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
